import { createCrudThunks } from "./utils/thunk";
import { createCrudReducer } from "./utils/reducer";

import api from "./CondicaoPagamento/api";

const label = "Condição de pagamento";
const entidade = "condicoesPagamento";

export const { get, add, update, deletar } = createCrudThunks(entidade, api, label);
const CondicaoPagamentoReducer = createCrudReducer(entidade, { get, add, update, deletar });

export {
  get as getCondicoesPagamento,
  add as addNewCondicaoPagamento,
  update as updateCondicaoPagamento,
  deletar as deleteCondicaoPagamento,
};

export default CondicaoPagamentoReducer;